// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2vEPq","validationTips":"StatementDescriptor_validationTips__2nPzj"};